<template>
  <div
    class="evaluation-rule"
    :class="{ active: hover, top: !indexPrefix }"
    @mouseover.stop="handleMouseover"
    @mouseout="handleMouseout"
  >
    <div class="parent">
      <!-- <span class="index">
        {{ cIndex }}
      </span> -->
      <div class="name" :style="{ paddingLeft: indent * 10 + 'px' }">
        <div>
          <span style="color: #409eff">{{ cIndex }}</span> {{ rule.name }}
        </div>
        <div
          style="font-size: 12px; color: gray"
          :style="{ paddingLeft: (indent + 1) * 12 + 'px' }"
        >
          {{ rule.comment }}
        </div>
      </div>
      <div class="score">
        <template v-if="rule.scoreable && totalScore">
          <el-tag :type="totalScore > 0 ? 'success' : 'danger'" size="mini" effect="dark"
            >{{ totalScore }} 分</el-tag
          >
        </template>
      </div>
      <div class="actions"></div>
    </div>
    <div class="points" v-if="rulePoints.length > 0">
      <PointCard
        :rule="rule"
        v-for="item in rulePoints"
        :key="item.id"
        :point="item"
        v-on="$listeners"
      ></PointCard>
    </div>
    <div class="children">
      <evaluation-rule
        v-for="(item, i) in rule.children"
        :rule="item"
        :key="item.id"
        :indexPrefix="cIndex"
        :index="i"
        :points="points"
        :type="type"
        v-on="$listeners"
      ></evaluation-rule>
    </div>
  </div>
</template>
<script>
import PointCard from "./point-card.vue";
export default {
  name: "EvaluationRule",
  data() {
    return {
      hover: false,
      currentPoints: null,
    };
  },
  components: { PointCard },
  computed: {
    cIndex() {
      return (
        this.indexPrefix + (this.indexPrefix ? "." : "") + (parseInt(this.index) + 1)
      );
    },
    // currentStatus() {},
    // 本条规则的评分点
    rulePoints() {
      return this.points.filter((item) => item.evaluation_rule_id === this.rule.id);
    },
    totalScore() {
      return this.rulePoints.reduce((total, item) => total + item.score, 0);
    },
    // 缩进
    indent() {
      return this.cIndex.split(".").length - 1;
    },
  },
  props: {
    rule: {
      type: Object,
      default: () => {
        return {};
      },
    },

    // 本任务的所有points
    points: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: String,
      default: "",
    },
    indexPrefix: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    handleMouseover() {
      this.hover = true;
    },
    handleMouseout() {
      this.hover = false;
    },
  },
};
</script>
<style lang="less" scoped>
.evaluation-rule {
  // border: 1px solid gray;
  margin: 5px 0;

  &.active {
    background-color: #f2f6fd;
  }

  &.top {
    border-left: 1px solid #1d81fc3f;
    border-right: 1px solid #1d81fc3f;
    margin-bottom: 10px;
    background-color: #fcfcfc;
  }
}

.parent {
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;

  &:hover {
    background-color: #dfeafd;
  }
}

.name {
  flex: 1;
  text-align: left;
}

.score {
  width: 150px;
  text-align: right;
  margin-right: 30px;

  .minus {
    color: red;
  }
}

.points {
  display: flex;
  padding: 10px 30px;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 40px 20px;
}
</style>
